import { render } from "./CompleteTaskCommentCreate.vue?vue&type=template&id=9b049902"
import script from "./CompleteTaskCommentCreate.vue?vue&type=script&lang=js"
export * from "./CompleteTaskCommentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__